module.exports = __webpack_public_path__ + "img/Pasarelas10.d7315358.jpg";